<div id="no-reflections">
  <!-- TODO: reflections - add localization -->
  <div class="sp-mt-64 sp-mb-32 t-align-c">
    <ui-icon uiTheme="fill" uiType="no-reflections" class="fs-64px sp-mr-12"></ui-icon>
  </div>
  <h2 class="sp-mb-24 t-align-c color-box text-color-gray-13 fw-600">Reflections</h2>
  <p class="sp-mb-20 text-color-gray-9">Use Reflections to align and share updates within your team. Answer questions, include Key Result updates, and comment on each other's progress.</p>
  <p class="sp-mb-32 text-color-gray-9">Only team members can access Reflections.</p>
  <div *ngIf="includeCTAButton" class="t-align-c">
    <button class="sp-px-24 hov-cursor-p text-color-gray-1" ui-button uiShape="round" uiType="primary" uiSize="large" (click)="onCTAClick.emit()">Fill out reflection</button>
  </div>
</div>
